// src/services/packageService.js
import apiClient from "./apiClient";

const endpoints = { base: "/admin/package" };

const normalizeStatus = (s) => {
  const v = String(s || "").toLowerCase();
  return v === "publish" ? "Publish" : "UnPublish";
};

export async function getAllPackages({ signal } = {}) {
  const res = await apiClient.get(endpoints.base, { signal });
  return res.data;
}

export async function addPackage(
  { totalCoin, amount, status },
  { signal } = {}
) {
  const body = {
    totalCoin: Number(totalCoin),            // server uses totalCoin
    amount: String(amount ?? ""),
    status: normalizeStatus(status),
  };
  const res = await apiClient.post(endpoints.base, body, { signal });
  return res.data;
}

// Send ONLY changed fields + id
export async function updatePackagePartial(
  { id, totalCoin, amount, status },
  { signal } = {}
) {
  if (!id) throw new Error("Package id is required");
  const body = { id };
  if (typeof totalCoin !== "undefined") body.totalCoin = Number(totalCoin);
  if (typeof amount !== "undefined") body.amount = String(amount);
  if (typeof status !== "undefined") body.status = normalizeStatus(status);

  const res = await apiClient.put(endpoints.base, body, { signal });
  return res.data;
}

export async function deletePackage({ id }, { signal } = {}) {
  const res = await apiClient.delete(endpoints.base, { signal, data: { id } });
  return res.data;
}
